<template>
  <div>
    <div class="centered">
      <div class="toolbar toolbar--small toolbar--toggles toolbar--centered">
        <button :class="{active: mode === 'Select'}" class="toolbar__button" @click="$emit('changeMode', 'Select')"><img src="@/assets/ui/action_edit.svg" alt=""></button>
        <button :class="{active: mode === 'Point'}" class="toolbar__button" @click="$emit('changeMode', 'Point')"><img src="@/assets/ui/action_point.svg" alt=""></button>
        <button :class="{active: mode === 'Polygon'}" class="toolbar__button" @click="$emit('changeMode', 'Polygon')"><img src="@/assets/ui/action_polygon.svg" alt=""></button>
        <button :class="{active: mode === 'Circle'}" class="toolbar__button" @click="$emit('changeMode', 'Circle')"><img src="@/assets/ui/action_circle.svg" alt=""></button>
      </div>
    </div>

    <hr>

    <template v-if="mode === 'Select'">
      <small>Selected plants:</small>
    </template>
    <template v-else>
      <small v-if="!plant">Please select a plant to plant</small>
      <small v-else>Planting "{{ plantName }}"</small>
    </template>

    <div class="garden__content__options__scroll_area" v-bar>
      <div>
        <div v-show="mode === 'Select'" class="plant-section">
          <button @click="$emit('trashSelection')" class="block mbs">
            <img src="@/assets/ui/action_trash.svg" alt=""> Delete selected plants
          </button>
          <map-plant-list-item v-for="mapPlant in selectedMapPlants"
                               :key="mapPlant.id"
                               :map-plant="mapPlant"
                               class="plant-section__plant"/>
        </div>
        <div v-show="mode !== 'Select'">
          <div v-for="layer in plantTree" :key="layer.id" class="plant-section" :class="layer.visible ? 'visible' : 'hidden'">
            <h3 :style="`border-bottom: 2px solid ${layer.borderColor}`"
                class="plant-section__title"
                @click="layer.visible = !layer.visible">
              {{ layer.name }}
            </h3>
            <div class="plant-section__content">
              <div class="plant-section__description">{{ layer.description }}</div>
              <ul class="plant-section__plants">
                <li v-for="p in layer.plants"
                    :key="p.id"
                    class="plant-section__plant"
                    :class="{active: plant === p.id}"
                    @click="$emit('changePlant', p.id)">
                  <img :src="`./pictures/${layer.id}/${p.picture}.svg`" alt="">
                  <h4>{{ p.name }}</h4>
                  <div class="plant-section__description">{{ p.description }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MapPlantListItem from '@/components/MapPlant/ListItem'
export default {
  name: 'GardenPlantOptions',
  components: { MapPlantListItem },
  props: {
    mode: { type: String, required: true },
    plant: { type: [Number, null], required: false, default: null },
    selectedMapPlantsIds: { type: Array, required: true },
  },
  data () {
    return {
      plantTree: {},
    }
  },
  computed: {
    plants () { return this.$store.getters.plants },
    layers () { return this.$store.getters.layers },
    plantName () {
      const plant = this.$store.getters.plant(this.$props.plant)
      return plant.name
    },
    selectedMapPlants () { return this.$store.getters.mapPlantsByIds(this.selectedMapPlantsIds) },
  },
  methods: {
    trashSelection () {
      this.$emit('trashPlants', this.selectedMapPlantsIds)
    },
    makePlantTree () {
      const plants = {}
      for (const layer of this.layers) {
        if (layer.id === 'mapPicture') continue

        plants[layer.id] = {
          ...layer,
          visible: false,
          plants: this.plants.filter((p) => p.layerId === layer.id),
        }
      }
      this.plantTree = plants
    },
  },
  created () { this.makePlantTree() },
  watch: {
    plants (_newValue, _oldValue) { this.makePlantTree() },
    layers (_newValue, _oldValue) { this.makePlantTree() },
  },
}
</script>
